/**
 * Default configuration constants for Sophi Widget
 */
export const DEFAULT_CONFIG = {
  /**
   * Default width of the widget iframe
   */
  WIDTH: "100%",

  /**
   * Default height of the widget iframe
   */
  HEIGHT: "600px",
} as const;

/**
 * API base URLs for different environments.
 * Values are injected at build time from environment variables via tsup.
 */
export const API_BASE_URLS = {
  test: process.env.SOPHI_API_URL_TEST as string,
  production: process.env.SOPHI_API_URL_PROD as string,
} as const;

/**
 * App (iframe) base URLs for different environments.
 * Values are injected at build time from environment variables via tsup.
 */
export const APP_BASE_URLS = {
  test: process.env.SOPHI_APP_URL_TEST as string,
  production: process.env.SOPHI_APP_URL_PROD as string,
} as const;

/**
 * API endpoints configuration
 */
export const API_ENDPOINTS = {
  /**
   * Session creation endpoint path
   */
  CREATE_SESSION: "/auth/v1/client/session",
} as const;

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  MISSING_API_KEY: "API key is required and must be a string",
  MISSING_CLIENT_ID: "Client ID is required and must be a string",
  MISSING_USER_ID: "User ID is required and must be a string",
  MISSING_CONTAINER: "Container is required",
  MISSING_IFRAME_URL: "Iframe URL is required and must be a string",
  INVALID_IFRAME_URL: "Invalid iframe URL",
  INVALID_ENVIRONMENT: "Invalid environment. Must be 'dev', 'test', 'staging', or 'production'",
  CONTAINER_NOT_FOUND: "Container element not found",
  NOT_INITIALIZED: "Widget not initialized. Call init() first.",
  ALREADY_INITIALIZED: "Sophi Widget is already initialized. Call destroy() first to reinitialize.",
  SESSION_CREATION_FAILED: "Failed to create authentication session",
  INVALID_SESSION_DATA: "Invalid session data received from API",
  YOU_NEED_TO_INIT_THE_WIDGET_FIRST: "You need to initialize the widget first. Call init() before calling this method.",
} as const;
